module.exports = __webpack_public_path__ + "static/media/vertex-11002x-m.2cbcde9b.jpg";